<template>
	<div>
		<el-card shadow="never">
			<el-form ref="form" :model="formData" :rules="rules" label-width="120px" size="small">
				<el-form-item label="预存金额(元)" prop="amount">
                    <el-input-number size="small" v-model="formData.amount" :controls="false" placeholder="请输入预存金额"></el-input-number>
				</el-form-item>
			</el-form>

			<div class="form-buttons-center">
				<el-button size="small" type="primary" :loading="saveLoading" @click="doSavePreStore">确 定</el-button>
				<el-button size="small" @click="doClose">取 消</el-button>
			</div>
		</el-card>
	</div>
</template>
<script>
import "@/assets/scss/common.scss";
import dlgForm from "@/mixin/dlgForm";
export default {
	name: "ChangePriceForm",
	mixins: [dlgForm],
	data() {
		return {
			rules: {
				amount: [
					{ required: true, message: "请输入预存金额", trigger: "blur" },
					{ type: 'number', min: 0, message: "必须是正数", trigger: "blur" },
				],
			},
		};
	},
	methods: {
		doSavePreStore() {
            const url = `/meter/web/basic/preStore/${this.formData.id}`;
            this._doSaveForm(this.$refs.form, url, 'PUT');
		},
	}
};
</script>
<style scoped>
.el-input-number::v-deep .el-input__inner {
    text-align: left;
}
</style>